import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Hindi = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        d="M3.908 9.092c1.017-.267 2.409-.775 2.409-1.517 0-.308-.217-.583-.692-.583-.608 0-1.4.45-2 .966L2.533 6.283c.834-.808 1.884-1.216 2.759-1.216 1.516 0 2.75 1.191 2.75 2.675 0 .466-.125.908-.325 1.291.366.159.825.225 1.258.225.433 0 .892-.066 1.258-.208V6.825H8.658l-.341-1.642h9.841l.342 1.642h-1.542v8.1l-2.191-.283V6.825h-2.342v8.1l-2.192-.283v-3.484a2.916 2.916 0 0 1-.45.042c-.525 0-1.05-.183-1.475-.483.309.466.484.975.484 1.483 0 1.317-1.117 2.525-2.85 2.525-1.942 0-3.525-1.533-4.317-3.75l1.433-.767c.609 1.584 1.534 2.434 2.525 2.434.792 0 1.317-.55 1.317-1.159 0-.366-.183-.766-.583-1.05-.484.3-1.034.492-1.542.584l-.867-1.925Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Hindi
